import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import type { SalesChannel, SalesChannelAPIResponse } from 'typings'
import { useFetch } from './useFetch'

type UseSalesChannelReturn = SalesChannel[]

export function useSalesChannels(
  options?: UseQueryOptions<UseSalesChannelReturn>
) {
  const { fetcherWrapper } = useFetch()

  async function fetcher(): Promise<UseSalesChannelReturn> {
    return fetcherWrapper(`/api/proxy/catalog_system/pvt/saleschannel/list`)
      .then((response) => response.json())
      .then((values: SalesChannelAPIResponse) =>
        values.map((sc) => ({ id: String(sc.Id), name: sc.Name }))
      )
  }

  return useQuery<UseSalesChannelReturn>({
    queryKey: ['sales-channels'],
    queryFn: fetcher,
    ...options,
  })
}
